import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.producer.fields.id'),
  },
  {
    name: 'logo',
    label: i18n('entities.producer.fields.logo'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'name',
    label: i18n('entities.producer.fields.name'),
  },
  {
    name: 'info',
    label: i18n('entities.producer.fields.info'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.producer.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.producer.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
